import { render, staticRenderFns } from "./listado-actas.vue?vue&type=template&id=7ff0af32&"
import script from "./listado-actas.vue?vue&type=script&lang=js&"
export * from "./listado-actas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports